'use client';

import { useCallback } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { deleteChannel } from '../functions/channel/deleteChannel';

/**
 * Delete a community channel. The Firestore channel-list
 * subscription delivers the removal to the master pane; the caller
 * is responsible for navigating away from the now-gone channel URL.
 */
export function useDeleteChannel({
  channelId,
}: {
  channelId: string | null | undefined;
}) {
  const creatorId = useCurrentUserId();
  return useCallback(async () => {
    if (!creatorId || !channelId) return;
    await deleteChannel({ creatorId, channelId });
  }, [creatorId, channelId]);
}
